import { createAction, handleActions } from 'redux-actions';

const ACTIVE_DEMENTIA_MODAL= 'dementia/ACTIVE_DEMENTIA_MODAL';

export const isACtiveDementiaBoxModal = createAction(ACTIVE_DEMENTIA_MODAL);

const initialState = {
  dementiaboxModal:{
    dementiaStatus:false,
    dementiaList:[]
  },
};

const dementia = handleActions(
  {
    [ACTIVE_DEMENTIA_MODAL]:   (state, { payload: dementiaboxModal }) => dementiaboxModal,
  },
  initialState
);

export default dementia;
